import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross1 } from "react-icons/rx";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { HiArrowUpRight } from "react-icons/hi2";

export default function Modal(props) {
  const { isOpen, selectedItem, type, handleClose } = props;
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10 " onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 mt-20 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-screen-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <a
                  className="fixed right-7 top-7 z-10 cursor-pointer rounded-full bg-white p-2 text-2xl text-gray-800 shadow-lg "
                  onClick={handleClose}
                >
                  <RxCross1 />
                </a>

                {/* Main Content */}
                {type === "review" ? (
                  <img
                    src={`./img/student/writing/${selectedItem.imgUrl}`}
                    alt=""
                  />
                ) : type === "tutor" ? (
                  <img src={selectedItem.modalImg} alt="" />
                ) : type === "blog" ? (
                  <OwlCarousel
                    className="owl-theme alltutor overflow-hidden"
                    items={1}
                    nav
                    navText={[
                      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
                      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
                    ]}
                  >
                    {selectedItem.imgUrl?.map((img) => (
                      <img
                        src={`/img/blog/${selectedItem.id}/${img}`}
                        className="rounded-2xl"
                        alt=""
                      />
                    ))}
                  </OwlCarousel>
                ) : type === "subject" ? (
                  <>
                    {selectedItem === "Math" ||
                    selectedItem === "Basic Math" ||
                    selectedItem === "Fur-Math" ? (
                      <OwlCarousel
                        className="owl-theme teaching overflow-hidden"
                        items={1}
                        margin={10}
                        nav
                        navText={[
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
                        ]}
                      >
                        <img
                          src="./img/krupee_info.jpg"
                          className="rounded-2xl"
                          alt=""
                        />
                        <img
                          src="./img/kruwee_info.jpg"
                          className="rounded-2xl"
                          alt=""
                        />
                      </OwlCarousel>
                    ) : selectedItem === "Chemistry" ? (
                      <OwlCarousel
                        className="owl-theme teaching overflow-hidden"
                        items={1}
                        margin={10}
                        nav
                        navText={[
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
                        ]}
                      >
                        <img
                          src="./img/kruterm_info.jpg"
                          className="rounded-2xl"
                          alt=""
                        />
                        <img
                          src="./img/krukit_info.jpg"
                          className="rounded-2xl"
                          alt=""
                        />
                      </OwlCarousel>
                    ) : selectedItem === "English" ||
                      selectedItem === "Eng-SL" ||
                      selectedItem === "Basic English" ? (
                      <img
                        src="./img/krubig_info.jpg"
                        className="rounded-2xl"
                        alt=""
                      />
                    ) : selectedItem === "Biology" ? (
                      <img
                        src="./img/krumean_info.jpg"
                        className="rounded-2xl"
                        alt=""
                      />
                    ) : selectedItem === "Physics" ?
                    <img
                    src="./img/kruterm_info.jpg"
                    className="rounded-2xl"
                    alt=""
                  />
                  :
                  ""
                  }
                  </>
                ) : (
                  ""
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
